import def_0 from "../components/Builder/Library/Theme/Definitions/fleetwoodusa.json";
import def_1 from "../components/Builder/Library/Theme/Definitions/naturalPolymers.json";
import def_2 from "../components/Builder/Library/Theme/Definitions/oc.json";
import def_3 from "../components/Builder/Library/Theme/Definitions/paroc.json";
import def_4 from "../components/Builder/Library/Theme/Definitions/titanium.json";
import def_5 from "../components/Builder/Library/Theme/Definitions/vidawool.json";

export default {
  "fleetwoodusa": def_0,
  "naturalPolymers": def_1,
  "oc": def_2,
  "paroc": def_3,
  "titanium": def_4,
  "vidawool": def_5,
};
